import Radium from 'radium';
import React from 'react';
import sortByOrder from 'lodash/collection/sortByOrder';
import { Link, RouteHandler, State } from 'react-router';
import { templateChildrenPages } from 'gatsby-helpers';

import ReindexTypography from '../ui/_ReindexTypography';

const { rhythm } = ReindexTypography;
const styles = {
  container: {
    display: 'flex',
    maxWidth: 960,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  content: {
    flex: 1,
    minWidth: 0,
    padding: `0 ${rhythm(1)}`,
  },
  sidebar: {
    width: `${100 * 3 / 12}%`,
    marginLeft: `${100 * 1 / 12}%`,
    '@media (max-width: 700px)': {
      display: 'none',
    },
  },
};

const BlogPage = React.createClass({
  mixins: [State],

  render() {
    let childPages = templateChildrenPages(__filename, this.props.state)
      .filter((child) => child.data)
      .map((child) => ({
        title: child.data.title,
        path: child.path,
        date: child.data.date,
      }));
    childPages = sortByOrder(childPages, ['date'], ['desc']);

    const posts = childPages.map((child) =>
      <li
        key={child.path}
        style={{
          marginBottom: rhythm(1 / 2),
        }}>
        <Link to={child.path}>
          {
            this.isActive(child.path) ?
              <strong>{child.title}</strong> :
              child.title
          }
        </Link>
      </li>
    );
    return (
      <div style={styles.container}>
        <div style={styles.content}>
          <RouteHandler {...this.props} />
        </div>
        <div style={styles.sidebar}>
          <h3>Reindex Blog</h3>
          <ul style={{ listStyle: 'none', margin: 0 }}>
            {posts}
          </ul>
        </div>
      </div>
    );
  },
});

export default Radium(BlogPage);



/** WEBPACK FOOTER **
 ** ./blog/_template.jsx
 **/